<template>
  <div class="about-page">
    <navbar
      is-blur="blur blur-rounded my-3 py-2 start-0 end-0 mx-4 shadow"
      btn-background="bg-gradient-success"
      :dark-mode="true"
    />
    <page-hero
      currentPage="N'Business"
      parentPage="À propos"
      title="N'Business: Solutions financières pour les entreprises"
      description="Des solutions de paiement et de transfert d'argent adaptées aux besoins des professionnels et des entreprises."
    />

    <section class="features-section py-6">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6" data-aos="fade-right">
            <div class="pe-lg-5">
              <h2 class="h1 mb-4">Une solution complète pour votre entreprise</h2>
              <p class="lead mb-4">
                N'Business est conçu pour répondre aux besoins spécifiques des entreprises
                en matière de transfert d'argent et de gestion des paiements.
              </p>
              <div class="d-flex mb-3">
                <div class="feature-icon">
                  <i class="fas fa-shield-alt"></i>
                </div>
                <div class="ms-3">
                  <h4>Sécurité maximale</h4>
                  <p>Protection de vos transactions avec les dernières technologies de cryptage.</p>
                </div>
              </div>
              <div class="d-flex mb-3">
                <div class="feature-icon">
                  <i class="fas fa-bolt"></i>
                </div>
                <div class="ms-3">
                  <h4>Rapidité d'exécution</h4>
                  <p>Transferts instantanés pour une gestion efficace de votre trésorerie.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6" data-aos="fade-left">
            <div class="position-relative">
              <img src="@/assets/img/mock-nolido-2-1285x1536.png" class="img-fluid rounded-lg" alt="N'Business App">
              <div class="floating-card">
                <div class="card-icon">
                  <i class="fas fa-chart-line"></i>
                </div>
                <div class="card-content">
                  <h5>+150%</h5>
                  <p>Croissance des transactions</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="benefits-section py-6 bg-light">
      <div class="container">
        <div class="row justify-content-center mb-5">
          <div class="col-lg-8 text-center">
            <h2 class="h1">Avantages pour votre entreprise</h2>
            <p class="lead">Découvrez comment N'Business peut transformer votre gestion financière</p>
          </div>
        </div>
        <div class="row g-4">
          <div class="col-md-4" v-for="(benefit, index) in benefits" :key="index" data-aos="fade-up" :data-aos-delay="index * 100">
            <div class="benefit-card">
              <div class="benefit-icon">
                <i :class="benefit.icon"></i>
              </div>
              <h4>{{ benefit.title }}</h4>
              <p>{{ benefit.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Testimonials Section -->
    <testimonials-section />
    
    <!-- FAQ Section -->
    <faq-section />

    <!-- Final CTA Section -->
    <section class="final-cta-section">
      <div class="container h-100 position-relative">
        
        <div class="row justify-content-center text-center pt-5 position-relative z-index-10">
          <div class="col-lg-8">
            <h2 class="text-white fw-bold mb-3" style="font-size: 1.8rem;">
              Vous avez choisi Nolido, et<br>
              <span class="position-relative d-inline-block">
                vous avez raison...
                <svg class="underline-svg" viewBox="0 0 200 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12 C 50 6, 150 6, 195 10" stroke="#F5A847" stroke-width="2.5" stroke-linecap="round"/>
                </svg>
              </span>
            </h2>
            <button class="btn btn-download-cta rounded-pill mt-2">
              Télécharger maintenant
            </button>
          </div>
        </div>

        <!-- Absolute Positioned Images (Desktop) -->
        <div class="phone-wrapper d-none d-lg-block">
           <img :src="require('@/assets/img/last_section_phone.png')" alt="Nolido App" class="phone-app-img">
        </div>

        <div class="collage-wrapper d-none d-lg-block">
           <img :src="require('@/assets/img/last_section.png')" alt="Communaute Nolido" class="collage-img">
        </div>

        <!-- Stacked Layout for Mobile/Tablet -->
         <div class="row align-items-center mt-5 d-flex d-lg-none">
          <div class="col-12 text-center mb-4">
             <div class="collage-wrapper">
                <img :src="require('@/assets/img/last_section.png')" alt="Communaute Nolido" class="img-fluid collage-img">
             </div>
          </div>
          <div class="col-12 text-center p-0">
            <div class="phone-wrapper">
              <img :src="require('@/assets/img/last_section_phone.png')" alt="Nolido App" class="img-fluid phone-app-img">
            </div>
          </div>
        </div>
      </div>
    </section>

    <app-footer />
  </div>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";
import PageHero from '@/components/PageHero.vue';
import TestimonialsSection from '@/components/TestimonialsSection.vue';
import FaqSection from '@/components/FaqSection.vue';

export default {
  name: 'AboutNBusiness',
  components: {
    Navbar,
    AppFooter,
    PageHero,
    TestimonialsSection,
    FaqSection
  },
  data() {
    return {
      benefits: [
        {
          icon: 'fas fa-money-bill-wave',
          title: 'Gestion de trésorerie',
          description: 'Optimisez vos flux de trésorerie avec des transferts instantanés et un suivi en temps réel.'
        },
        {
          icon: 'fas fa-chart-bar',
          title: 'Rapports détaillés',
          description: 'Accédez à des analyses complètes et des rapports personnalisés de vos transactions.'
        },
        {
          icon: 'fas fa-users',
          title: 'Multi-utilisateurs',
          description: 'Gérez les accès et les permissions de votre équipe en toute sécurité.'
        }
      ]
    }
  }
}
</script>

<style scoped>
/* Final CTA Styles */
.final-cta-section {
  background-color: #2F2113;
  position: relative;
  overflow: hidden;
  height: 700px;
  padding-top: 2rem;
  background-image: url('~@/assets/img/bande_gauche.png');
  background-position: left 50px;
  background-repeat: no-repeat;
  background-size: 350px auto;
  margin-top: 0; 
}

.underline-svg {
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 250px; 
  height: auto;
}

.btn-download-cta {
  background-color: #eebb89;
  color: #2F2113;
  font-weight: 700;
  border: none;
  font-size: 0.95rem;
  padding: 0.6rem 2rem;
  box-shadow: 0 4px 0 #c29568;
  transition: transform 0.2s, box-shadow 0.2s;
  position: relative;
  z-index: 10;
}

.btn-download-cta:hover {
  transform: translateY(2px);
  box-shadow: 0 2px 0 #c29568;
}

.phone-wrapper {
  position: absolute;
  bottom: -40px;
  left: 5%;
  z-index: 5;
  width: 280px; 
}

.phone-app-img {
  width: 100%;
  height: auto;
}

.collage-wrapper {
  position: absolute;
  bottom: 60px;
  right: 2%;
  z-index: 5;
  width: 360px;
}

.collage-img {
  width: 100%;
  height: auto;
  transform: rotate(3deg);
  border-radius: 12px;
}

@media (max-width: 991px) {
  .final-cta-section {
    height: auto;
    min-height: 500px;
    padding-bottom: 0;
    background-image: none;
    padding-top: 3rem;
  }
  
  .phone-wrapper {
    position: relative;
    bottom: 0;
    left: 0;
    margin-top: 2rem;
    margin-bottom: -10px;
    display: inline-block;
  }
  
  .collage-wrapper {
    position: relative;
    bottom: 0;
    right: 0;
    display: inline-block;
  }
  
  .collage-img {
    transform: rotate(0);
  }
}

/* Feature Section Styles */
.feature-icon {
  width: 48px;
  height: 48px;
  background: #F69800;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.25rem;
  flex-shrink: 0;
}

.floating-card {
  position: absolute;
  bottom: 30px;
  right: -20px;
  background: white;
  padding: 1.5rem;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
  animation: float 3s ease-in-out infinite;
}

.card-icon {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #F69800 0%, #fba827 100%);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.card-content h5 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
}

.card-content p {
  font-size: 0.875rem;
  color: #6c757d;
  margin: 0;
}

.benefit-card {
  background: white;
  padding: 2rem;
  border-radius: 16px;
  height: 100%;
  transition: all 0.3s ease;
}

.benefit-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
}

.benefit-icon {
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #F69800 0%, #fba827 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-15px); }
}

@media (max-width: 991.98px) {
  .floating-card {
    position: static;
    margin-top: 2rem;
  }
}
</style>